import ChessRestClient from '@/Api/ChessRestClient';
import { useMutation } from '@tanstack/react-query';

export interface OTBGamePayload {
    game_date: string;
    round_no: number;
    opponent_rating: number;
    time_class: string;
    color: string;
    result: number;
    pgn_content: string;
    tournament_id: number | null;
    tournament_name: string;
}

export default function useCreateAndPublishOTBGamesApi(
    handleOnSuccess?: (data: any) => void,
    handleOnError?: (data: any) => void,
) {
    const mutation = useMutation<any, Error, { games: OTBGamePayload[] }>(
        async payload => {
            const response = await ChessRestClient.post(
                'learning/create-and-publish-otb-games/',
                payload,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Accept: 'application/json',
                    },
                },
            );
            return response.data;
        },
        {
            onSuccess: data => handleOnSuccess?.(data),
            onError: data => handleOnError?.(data),
        },
    );
    return { ...mutation };
}